import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/hooks/useLanguage";
import { Link } from "react-router-dom";

export const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);
  const { t } = useLanguage();

  useEffect(() => {
    // Check if user has already consented
    const hasConsented = localStorage.getItem("cookieConsent") === "true";
    
    if (!hasConsented) {
      // If no consent yet, show the modal and prevent scrolling
      setShowConsent(true);
      document.body.style.overflow = "hidden";
    }
    
    // Cleanup function to restore scrolling when component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  const handleAccept = () => {
    // Store consent in localStorage
    localStorage.setItem("cookieConsent", "true");
    
    // Hide the modal and restore scrolling
    setShowConsent(false);
    document.body.style.overflow = "auto";
  };

  if (!showConsent) return null;

  return (
    <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg max-w-md w-full p-6 animate-fade-in">
        <h2 className="text-xl font-bold mb-4 text-black">
          {t('auth.cookieConsent.title') || 'Cookie Consent'}
        </h2>
        <p className="mb-6 text-gray-600 dark:text-gray-300">
          {t('auth.cookieConsent.description') || 
            'This website uses cookies to enhance your browsing experience, including essential cookies for site functionality, analytics cookies to improve our services, and advertising cookies to display relevant ads for free-tier users. By clicking "Accept", you consent to the use of cookies in accordance with our Cookie Policy.'}
        </p>
        <div className="flex flex-col space-y-3">
          <Button 
            onClick={handleAccept}
            className="w-full bg-[#7E69AB] hover:bg-[#6E59A5] text-white"
          >
            {t('auth.cookieConsent.accept') || 'Accept Cookies'}
          </Button>
          <div className="text-xs text-center text-gray-500 dark:text-gray-400">
            {t('auth.cookieConsent.readMore') || 'To learn more, please read our '}
            <Link 
              to="/privacy-policy" 
              className="text-[#7E69AB] hover:underline"
              onClick={(e) => {
                // Store temporary consent to allow navigation to privacy policy
                localStorage.setItem("temporaryCookieConsent", "true");
              }}
            >
              {t('auth.cookieConsent.privacyPolicy') || 'Privacy Policy'}
            </Link>
            {' '}
            {t('auth.cookieConsent.and') || 'and'}{' '}
            <Link 
              to="/terms-of-service" 
              className="text-[#7E69AB] hover:underline"
              onClick={(e) => {
                // Store temporary consent to allow navigation to terms
                localStorage.setItem("temporaryCookieConsent", "true");
              }}
            >
              {t('auth.cookieConsent.termsOfService') || 'Terms of Service'}
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
